"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValid = isValid;
exports.isValidUrl = isValidUrl;
exports.isValidDynoUrl = isValidDynoUrl;
exports.getValidationErrorKey = getValidationErrorKey;
exports.maybeShowInvalidMessage = maybeShowInvalidMessage;
exports.isValidSubjectLineText = isValidSubjectLineText;

var _react = _interopRequireDefault(require("react"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var URL_REGEX = /^https?:\/\/[^\s\.]+\.[^\s]{2,}$/;
var DYNO_URL_REGEX = /^((https?:)?\/\/)?[^\s\.]+\.[^\s]{2,}$/; // accepts protocol-agnostic and protocol missing

var RE_REGEX = /^\s*(re|RE|rE|Re)(\s|;|:)/;

function isValid(validationState, field) {
  return validationState[field] === undefined;
}

function isValidUrl(url) {
  var allowEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (allowEmpty && url === '') {
    return true;
  }

  return URL_REGEX.test(url);
}

function isValidDynoUrl(url) {
  var allowEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (allowEmpty && url === '') {
    return true;
  }

  return DYNO_URL_REGEX.test(url);
}

function getValidationErrorKey(validation) {
  try {
    var step = validation[Object.keys(validation)[0]];
    var field = step ? step[Object.keys(step)[0]] : null;
    return field;
  } catch (e) {
    return null;
  }
}

function maybeShowInvalidMessage(messagePath) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return messagePath ? _react.default.createElement(_FormattedReactMessage.default, {
    message: messagePath,
    options: options
  }) : undefined;
}

function isValidSubjectLineText(line) {
  return !RE_REGEX.test(line);
}